import { Box } from '@mui/material'
import { useEffect, useState } from 'react'
import Header from '../header/header'
import DrawerCustom from '../drawer/drawer'
import { LayoutMainStyle } from './layoutMainStyle'
interface propsTypes {
    children: any
}
export default function LayoutMain(props: propsTypes) {
    const { children } = props

    const [drawerOpen, setDrawerOpen] = useState<boolean>(false)
    const [url, setUrl] = useState<string>('')
    useEffect(() => {
        const init = async () => {
          const response = await fetch("/resources/config.json");
          const results = await response.json();
          setUrl(results.REACT_APP_BASE_API);
        }
        init()
      }, [])
    return (
        <LayoutMainStyle>
            <DrawerCustom drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} url={url}/>
            <div style={{ width: "100%", height:'100vh', overflowY:'auto' }}>
                <Header drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} url={url}/>
                {children}
            </div>

        </LayoutMainStyle>
    )
}
